import { render, staticRenderFns } from "./DragAndDropFiles.vue?vue&type=template&id=5f2c1a34&scoped=true&"
import script from "./DragAndDropFiles.vue?vue&type=script&lang=js&"
export * from "./DragAndDropFiles.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropFiles.vue?vue&type=style&index=0&id=5f2c1a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2c1a34",
  null
  
)

export default component.exports